var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('carousel_panel'),_c('node_construction'),_c('identity_query'),_c('login_box'),_c('the_solution'),_c('app_store'),_c('policy_declaration'),_c('news_list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }